// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"cc18c449","363":"b413a519","453":"7b6e9bd6","525":"b6be4e15","605":"ac94981a","634":"c81e694b","990":"aa62e4bc"}[chunkId] + ".chunk.js";
};